import { Component } from '@angular/core';
import { FormsService } from '../../services/forms.service';
import { ModalService, ModalType } from '../../services/modal.service';
import { isToday, toDateString } from '../../utils';
import isAppAgentOrTravelAgency from '../../utils/is-agent-or-travel-agency.util';
import { MAX_INSURANCE_DIFF, MIN_INSURANCE_DIFF_PL } from '../settings';
import { environment } from '../../environments/environment';
import { AppType } from '../../model/app-type.model';

@Component({
  selector: 'app-form-travel-in-pl',
  templateUrl: './travel-in-pl.component.html',
})
export class TravelInPlComponent {
  formGroup = this.formsService.travelInPl;
  modalType = ModalType;
  isAppTravelAgency = environment.app === AppType.TravelAgency;
  isAppAgentOrTravelAgency = isAppAgentOrTravelAgency();
  today = new Date().toString();

  hiRiskValues = [
    { value: true, label: 'information-about-journey.allHighRisk.options.true' },
    { value: false, label: 'information-about-journey.allHighRisk.options.false' },
  ];

  competitiveSportsValues = [
    { value: true, label: 'information-about-journey.extremeSportsForAllInsureds.options.true' },
    { value: false, label: 'information-about-journey.extremeSportsForAllInsureds.options.false' },
  ];

  constructor(public modalService: ModalService, private formsService: FormsService) {}

  get personsWithLabelArgs(): Record<string, string>[] {
    return (
      this.formGroup.controls.insuredBirthYear?.value.map((birthYear) => ({
        year: String(birthYear || '----'),
      })) || []
    );
  }

  get minDate(): string | undefined {
    const date = new Date();
    date.setDate(date.getDate() + MIN_INSURANCE_DIFF_PL);

    return toDateString(date);
  }

  maxDate(dateAsString: string | null): string | undefined {
    if (!dateAsString) {
      return undefined;
    }

    const date = new Date(dateAsString);
    date.setDate(date.getDate() + MAX_INSURANCE_DIFF);

    return toDateString(date);
  }

  isTodaySelected(date: string | Date | null): boolean | null {
    return date ? isToday(date) : null;
  }
}
